import { Component } from '@angular/core';

@Component({
  selector: 'app-not-modules',
  templateUrl: './not-modules.component.html',
  styleUrls: ['./not-modules.component.css']
})
export class NotModulesComponent  {
  //userActive= (sessionStorage.SARToken != null) ? true : false;

}
